import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { ThreadView, ThreadPostForm } from './';
import { SingleThreadPosts } from './SingleThreadPosts';
import BackButton from '../../../../../dashboardNew/components/tools/BackButton';

import {
    replyToThread,
    resetStatus
} from '../../../../../../actions/forums/forums';
import { Pagination, Loader } from '../../../../../common/elements';
import { PaginationHelpers as Page } from '../../../../../../helpers';
import ThemePageBanner from '../../../../../dashboardNew/components/ThemePageBanner';

class Thread extends Component {

    state = {
        bannerObj: '',
        quote: ''
    }

    componentWillUnmount() {
        this.props.resetStatus();
    }

    componentDidMount() {
        const locationUrl = window.location.pathname.split('/')[2];
        let bannerObj
        switch (locationUrl) {
            case '1':
                bannerObj = { title: 'General Discussion', img: '/images/bg-members.jpg' }
                break;
            case '2':
                bannerObj = { title: 'Recruitment', img: '/images/bg-forum.jpg' }
                break;
            case '3':
                bannerObj = { title: 'Introductions', img: '/images/contact.jpg' }
                break;
            default:
                bannerObj = { title: 'Introductions', img: '/images/contact.jpg' }
        }

        this.setState({ bannerObj })
    }

    postToThread(post) {
        const {
            threadId,
            replyToThread,
            resetForm
        } = this.props;
        if (post) {
            replyToThread(threadId, post);
        }
        resetForm();
    };

    quoteReplyHandler = () => {
        if (this.props.threadId === this.props.thread.id.toString()) {
            const quote = this.props.thread.description.replace(/(&nbsp;|<([^>]+)>)/ig, "");
            this.setState({
                quote: quote
            })
        }
    }

    render() {
        const { thread, posts, status, paging, location, getNextPosts } = this.props;
        const totalPages = paging.total_pages,
            pageLocation = location.query.page,
            currentPage = Page.setCurrentPage(pageLocation, totalPages),
            pagination_details = Page.getCurrentPage(currentPage, totalPages),
            pageNumbers = Page.getPageNumbers(pagination_details);

        if (!thread || !posts || !paging) {
            return <Loader />;
        }

        return (
            <section className="forum-body">
                <ThemePageBanner heading={this.state.bannerObj.title} image={this.state.bannerObj.img} />
                <div className="container padding-top">
                    <div className="forum-back-button">
                        <BackButton
                            title="Go Back"
                            path={`/forums/${thread.category_id}/threads`}
                        />
                    </div>

                    <ThreadView quoteReplyHandler={this.quoteReplyHandler} thread={thread} />

                    <SingleThreadPosts posts={posts} />
                    {
                        status && <h4 className="h4 brand-color text-center">Your post has been added</h4>
                    }
                    <ThreadPostForm quote={this.state.quote} onSubmit={(post) => this.postToThread(post)} />
                    <div className="row">
                        <div className="col-xs-12">
                            {
                                totalPages > 1 ? (
                                    <Pagination
                                        currentPage={currentPage}
                                        pagination={pagination_details}
                                        pageNumbers={pageNumbers}
                                        totalPages={totalPages}
                                        onPaginationClick={(currentPage) => getNextPosts(currentPage)}
                                    />
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </section>
        );
    };
}

Thread.propTypes = {
    status: PropTypes.bool,
    threadId: PropTypes.string,
    posts: PropTypes.array,
    paging: PropTypes.object,
    location: PropTypes.object,
    replyToThread: PropTypes.func,
    resetForm: PropTypes.func,
    resetStatus: PropTypes.func
}

const mapStateToProps = (state) => {
    return {
        status: state.forums.status,
        categories: state.forums.categories
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        replyToThread: (threadId, post) => dispatch(replyToThread(threadId, post)),
        resetForm: () => dispatch(reset('discussion_reply')),
        resetStatus: () => dispatch(resetStatus()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Thread);



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/Thread.js